import { useMemo, useRef } from 'react';

export const useDomainWhitelisted = () => {
  const whitelisted = useRef([
    'https://dental.joingotu.com',
    'https://dental.tempmee.com',
    'https://dental.dev.tempdee.com',
    'https://dental.dev.joingotu.com',
    'https://dental.staging.tempdee.com',
    'https://dental.staging.joingotu.com',
    'http://localhost:8080',
  ]).current;

  const isWhitelisted = useMemo(() => whitelisted.includes(window.location.origin), [whitelisted]);

  const targetUrl = useMemo(() => {
    if (!isWhitelisted) {
      return null;
    }

    if (window.location.origin === 'http://localhost:8080') {
      return 'https://dental.gotu.com';
    }

    const pattern = new RegExp(/temp(d|m)ee|joingotu/, 'i');

    return window.location.origin.replace(pattern, 'gotu');
  }, [isWhitelisted]);

  return { isWhitelisted, targetUrl };
};
